<div class="row">
  <div class="col-md-12 activity-buttons">
    @if (!isDead && availableSequences.length > 0) {
      <button
        mat-raised-button
        class="subscribe-sequence"
        [matMenuTriggerFor]="menu">
        Subscribe
      </button>
    }
    <mat-menu #menu="matMenu">
      @for (sequence of availableSequences; track sequence) {
        <button
          mat-menu-item
          (click)="subscribeToSequence(sequence)">
          {{ sequence.name }}
        </button>
      }
    </mat-menu>

    @if (hasDeadPermissions && !isDead) {
      <button
        mat-raised-button
        color="warn"
        class="dead-sequence"
        (click)="deadConfirmation()">
        Mark as Dead
      </button>
    }

    @if (hasRequirements) {
      <button
        mat-raised-button
        color="primary"
        class="resurrect-deal"
        (click)="handleMissingData(true)">
        View Missing Data
      </button>
    }

    <!--    <button mat-raised-button class="toggle-view" color="accent"-->
    <!--            matTooltip="Tabular View"-->
    <!--            *ngIf="isTimelineView"-->
    <!--            (click)="isTimelineView = !isTimelineView">-->
    <!--      <mat-icon>backup_table</mat-icon>-->
  <!--    </button>-->

  <!--    <button mat-raised-button class="toggle-view" color="accent"-->
  <!--            matTooltip="Timeline View"-->
  <!--            *ngIf="!isTimelineView"-->
  <!--            (click)="isTimelineView = !isTimelineView">-->
  <!--      <mat-icon>timeline</mat-icon>-->
<!--    </button>-->
</div>
</div>
<div class="row align-top gutters">
  <div class="col-md-12">
    @if (statuses) {
      <div>
        @if (isDead) {
          <div class="dead-deal">
            <mat-icon color="warn">report</mat-icon><b>Dead</b
            >@if (deadDate) {
            <span>: {{ deadDate }}</span>
          }
        </div>
      }
      @for (sequence of statusSequenceDates; track sequence; let i = $index) {
        <div>
          @if (sequence.sequence.name !== 'Dead') {
            <div>
              <div class="sequence-title">
                <span class="status-header">{{ sequence.sequence.name }}</span>
                @if (
                  !isDead &&
                  sequence.sequence.active &&
                  (sequence.sequence.hasPermissions ||
                  (sequence.sequence.name === 'Closing' &&
                  permissions.forecastApprovalDateTypePermissions._edit))
                  ) {
                  <button
                    mat-mini-fab
                    matTooltip="Edit Dates"
                    color="primary"
              (click)="
                sequence.sequence.isEditMode = !sequence.sequence.isEditMode
              ">
                    @if (!sequence.sequence.isEditMode) {
                      <mat-icon>edit</mat-icon>
                    }
                    @if (sequence.sequence.isEditMode) {
                      <mat-icon>check</mat-icon>
                    }
                  </button>
                }
                @if (
                  !isDead &&
                  sequence.sequence.active &&
                  !sequence.sequence.is_primary &&
                  sequence.sequence.hasPermissions
                  ) {
                  <button
                    mat-mini-fab
                    matTooltip="Unsubscribe Status Sequence"
                    color="warn"
                    (click)="unsubscribeConfirmation(sequence)">
                    <mat-icon>clear</mat-icon>
                  </button>
                }
              </div>
              <app-timeline
                [status_and_dates]="sequence"
                [dispositions]="false"
                [permissions]="permissions"
                [isEditMode]="sequence.sequence.isEditMode"
                [dateDelete]="dateDelete"
                [style.display]="isTimelineView ? '' : 'none'"
                [hasRequirements]="hasRequirements"
                [isMobile]="isMobile"
                (dateChange)="passDate($event)"
                (deleteDate)="deleteDateConfirmation($event, i)"
                (deleteForecastDate)="deleteForecastDateConfirmation($event, i)"
                (hasMissingData)="handleMissingData($event)"
                (statusChange)="passStatuses($event)"
                [subsequences]="subsequences"
                [projectCredits]="projectCredits"
                [(projectSubstatusDates)]="projectSubstatusDates"
              [(projectSubstatuses)]="projectSubstatuses"></app-timeline>
              <deal-tabular-pipeline-dates
                [status_and_dates]="sequence"
                [permissions]="permissions"
            [style.display]="
              isTimelineView ? 'none' : ''
            "></deal-tabular-pipeline-dates>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
</div>
